import {CheckTypeSelect} from "@/components/checkTypeSelect/CheckTypeSelect.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {FormLabel} from "@/components/form/FormLabel.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {MonitoringServiceType, ServiceDefinition, ServiceGroup} from "@/lib/types/checks.ts";

interface Props {
  svc: ServiceDefinition;
  monitoringServiceTypes: ServiceGroup[];
  serviceType: MonitoringServiceType;
  setServiceType: (t: MonitoringServiceType) => void;
  disabled?: boolean;
}

// This component is unique and doesn't use react-hook-from and used with a callback. it is used specifically in check creation and editing forms.
// If you need a react-hook-form version, please follow the pattern in UserSelectField.tsx or TagSelect.tsx. and rename this to indicate it doesn't use react-hook-form.
export const ServiceTypeField = ({svc, monitoringServiceTypes, serviceType, setServiceType, disabled}: Props) => {
  const {userHasFeature} = useCurrentUserContext();
  const options = monitoringServiceTypes.map((st) => ({
    label: st.group,
    options: st.types,
  }));

  const selectedGroup = options.find((group) => group.options.some((a) => a.name === serviceType));
  const selectedValue = selectedGroup?.options?.find((option) => option.name === serviceType);
  return (
    <>
      <FormLabel forId="monitoring_service_type" required>
        Check Type
      </FormLabel>
      <CheckTypeSelect
        options={options}
        defaultValue={selectedValue}
        value={selectedValue}
        onChange={(v) => {
          setServiceType(v!.name as MonitoringServiceType);
        }}
        isClearable={false}
        isSearchable={true}
        isDisabled={disabled}
      />
      <div className="d-flex flex-column">
        <FormSubtext subText={svc.help_text} supportLink={svc.support_link} />
        {serviceType === MonitoringServiceType.TRANSACTION && userHasFeature("transaction-recorder") && (
          <div className="pulseTextBodySmall pulse-color-gray-700">
            Install our{" "}
            <a
              target="_blank"
              href="https://chromewebstore.google.com/detail/uptimecom-transaction-rec/jiiejololhdhdhfefdaokjkgfpmdbiio"
            >
              Free Chrome Transaction Recorder
            </a>
          </div>
        )}
      </div>
    </>
  );
};
